import type React from "react"

interface CardProps {
  title: React.ReactNode
  children: React.ReactNode
}

const Card: React.FC<CardProps> = ({ title, children }) => {
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg w-full">
      <div className="px-2 py-4 sm:px-4">
        <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
      </div>
      <div className="border-t border-gray-200">{children}</div>
    </div>
  )
}

export default Card
